<template>
  <div v-loading="loading" class="page-form">

    <h3 class="title">发货计划审批</h3>

    <div class="form-container">
      <div class="tools">
        <btky-header
          :form-data="conditions"
          :process-key="processKey"
          @validate="validate"
          @formDataSave="saveData"
          @advanceSuccess="advanceSuccess"
        />
      </div>
      <el-form ref="form" inline size="mini" label-width="100px" :disabled="isEdit" :model="conditions" :rules="rules">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item prop="billCode" class="widget-view" label="月度计划编号" label-width="">
              <el-input
                v-model="conditions.billCode"
                disabled
                placeholder="自动生成"
                type="text"
                name="wlyMakePlanOrderPo.billCode"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="billType" class="widget-view" label="创建人" label-width="">
              <el-input
                v-model="conditions.createdByName"
                disabled
                placeholder="请输入"
                type="text"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="customerName" class="widget-view" label="创建时间" label-width="">
              <el-input
                v-model="conditions.createdDate"
                disabled
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="客户名称" label-width="">
              <el-input
                v-model="conditions.partnerName"
                placeholder="请输入"
                type="text"
                clearable
                @focus="openDialog($event, '客户选择')"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="客户类型" label-width="">
              <el-select
                v-model="conditions.customerType"
                disabled
                placeholder="请选择"
                type="select"
              >
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="widget-view" label="计划年度" label-width="">
              <el-date-picker
                v-model="conditions.pyear"
                type="year"
                value-format="yyyy"
                format="yyyy"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon
        title="明细信息"
        :custome-config="() => vxeShowCustom('xTable')"
      >
        <template #button>
          <table-button name="add" tip="增加" @click="insertData" />
          <table-button name="delete" tip="删除" @click="removeData" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="medium"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{name: 'NotData'}"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <el-input
                v-if="
                  gridOptions.columnsFieldTypes[item.field] == 'input' && item.field === 'productId'
                "
                v-model="row[item.field]"
                placeholder="请选择"
                :disabled="isEdit"
                size="mini"
                suffix-icon="el-icon-more"
                @focus="openDialog($event, '产品选择', row)"
              />
              <el-select
                v-else-if="
                  gridOptions.columnsFieldTypes[item.field] == 'select' && item.field === 'brand'
                "
                v-model="row[item.field]"
                size="mini"
                filterable
              >
                <el-option
                  v-for="selectItem in selectDataOptions['A0019']"
                  :key="selectItem.value"
                  :value="selectItem.value"
                  :label="selectItem.name"
                />
              </el-select>
              <el-input
                v-else-if="gridOptions.columnsFieldTypes[item.field] == 'input'"
                v-model="row[item.field]"
                type="number"
                :disabled="isEdit"
                size="mini"
              />
              <el-select
                v-else-if="
                  gridOptions.columnsFieldTypes[item.field] == 'select' && item.field === 'zqdlx'
                "
                v-model="row[item.field]"
                :disabled="isEdit"
                size="mini"
              >
                <el-option
                  v-for="selectItem in selectDataOptions['goodsPlanType']"
                  :key="selectItem.value"
                  :value="selectItem.value"
                  :label="selectItem.name"
                />
              </el-select>
              <el-select
                v-else-if="
                  gridOptions.columnsFieldTypes[item.field] == 'select' && item.field === 'zyxdy'
                "
                v-model="row[item.field]"
                size="mini"
                :disabled="isEdit"
              >
                <el-option
                  v-for="selectItem in selectDataOptions['orgList']"
                  :key="selectItem.zzfld00001h"
                  :label="selectItem.mc_short"
                  :value="selectItem.zzfld00001h"
                />
              </el-select>
              <span v-else>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>
      <btky-footer :form-data="conditions" />
    </div>

    <!-- <btky-footer :form-data="conditions" /> -->

    <!-- 通用弹窗情况 -->
    <el-dialog v-dialogDrag :title="dialogTitle" :visible.sync="showDialog" width="70%" :append-to-body="true">
      <template v-if="showDialog">

        <client-select v-if="dialogTitle === '客户选择'" ref="dialogSelect" />
        <product-select v-if="dialogTitle === '产品选择'" ref="dialogSelect" :query-params="{ customerCode: conditions.partner }" />
      </template>

      <div slot="footer">
        <el-button type="default" icon="el-icon-circle-close" size="small" @click="showDialog = false">取消</el-button>
        <el-button type="primary" icon="el-icon-circle-check" size="small" @click="submitHandle">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiMonthplanFindById } from '@/api/applyForGoods/monthly'
import { handlerFlow } from '@/api/flowHander'
import { apiSapClientFindInfo } from '@/api/common'

import { mapGetters } from 'vuex'
const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
const ProductSelect = () => import('@/components/dialog/ProductSelect.vue')

export default {
  components: { ClientSelect, ProductSelect },
  data() {
    return {
      rules: {},
      loading: false,
      processKey: 'ztcrmTgpplanM1',
      dialogTitle: '',
      showDialog: false,
      validRules: {},
      conditions: {
        id: '',
        bizId: '',
        taskId: '',
        zyear: '',
        pyear: '',
        partner: '',
        status: 0,
        billCode: '',
        customerName: '',
        customerType: '',
        createdDate: '',
        createdByName: '',
        ztcrmTgpplanM1List: []
      },
      selectDataOptions: {},
      currentRow: null,
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 40 },
          // { field: 'productId', title: '产品编码', width: 120, slots: { default: 'productId' }},
          {
            field: 'brand', title: '存货分类', width: 120, slots: { default: 'brand' }
          },
          // { field: 'amtAllInit', title: '全年初始计划量', width: 110, slots: { default: 'amtAllInit' }},
          // { field: 'amountAll', title: '全年计划量', width: 80, slots: { default: 'amountAll' }},
          { field: 'zqdlx', title: '渠道类型', width: 120, slots: { default: 'zqdlx' }},
          { field: 'qdjhl', title: '渠道计划量', width: 100, slots: { default: 'qdjhl' }},
          // { field: 'amtAllqdInit', title: '全年渠道初始计划量', width: 140, slots: { default: 'amtAllqdInit' }},
          { field: 'zyxdy', title: '营销单元', width: 140, slots: { default: 'zyxdy' }},
          { field: 'm12Plan', title: '12月计划量', width: 110, slots: { default: 'm12Plan' }},
          { field: 'm1Plan', title: '1月计划量', width: 100, slots: { default: 'm1Plan' }},
          { field: 'm2Plan', title: '2月计划量', width: 100, slots: { default: 'm2Plan' }},
          { field: 'm3Plan', title: '3月计划量', width: 100, slots: { default: 'm3Plan' }},
          { field: 'm4Plan', title: '4月计划量', width: 100, slots: { default: 'm4Plan' }},
          { field: 'm5Plan', title: '5月计划量', width: 100, slots: { default: 'm5Plan' }},
          { field: 'm6Plan', title: '6月计划量', width: 100, slots: { default: 'm6Plan' }},
          { field: 'm7Plan', title: '7月计划量', width: 100, slots: { default: 'm7Plan' }},
          { field: 'm8Plan', title: '8月计划量', width: 100, slots: { default: 'm8Plan' }},
          { field: 'm9Plan', title: '9月计划量', width: 100, slots: { default: 'm9Plan' }},
          { field: 'm10Plan', title: '10月计划量', width: 110, slots: { default: 'm10Plan' }},
          { field: 'm11Plan', title: '11月计划量', width: 110, slots: { default: 'm11Plan' }},
          { field: 'initPlanNum', title: '待分解量', width: 100, slots: { default: 'initPlanNum' }}
        ],
        data: [],
        columnsFieldTypes: {
          brand: 'select',
          // amountAll: 'input',
          // amtAllInit: 'input',
          // qdjhl: 'input',
          zqdlx: 'select',
          // amtAllqdInit: 'input',
          zyxdy: 'select',
          m1Plan: 'input',
          m2Plan: 'input',
          m3Plan: 'input',
          m4Plan: 'input',
          m5Plan: 'input',
          m6Plan: 'input',
          m7Plan: 'input',
          m8Plan: 'input',
          m9Plan: 'input',
          m10Plan: 'input',
          m11Plan: 'input',
          m12Plan: 'input',
          initPlanNum: 'input'
        }
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isEdit() {
      return true
    }
  },
  watch: {
    'gridOptions.data': {
      handler(newVal) {
        this.conditions.ztcrmTgpplanM1List = newVal
      },
      deep: true
    }
  },
  created() {
    this.getSelectDictDataOrigin('A0009')
    this.getSelectDictDataOrigin('A0054')
    this.getSelectDictDataOrigin('goodsPlanType')
    this.getSelectDictDataOrigin('A0019')
    const { id, taskId } = this.$route.query
    if (id) {
      this.conditions.id = id
      this.conditions.bizId = id
      taskId && (this.conditions.taskId = taskId)
      this.initDetail()
    } else {
      this.initCustome()
    }
  },
  methods: {
    // 查询客户信息
    async initCustome() {
      const params = { rt_partner: [{
        SIGN: 'I',
        OPTION: 'EQ',
        LOW: this.conditions.partner,
        HIGH: ''
      }], page: 1, pagesize: 50 }
      // 当前登录账号和角色
      params.partner = this.$store.getters.role.USER_BP
      params.role = this.$store.getters.role.ROLE
      const { data } = await apiSapClientFindInfo(params)
      this.$set(this.selectDataOptions, 'orgList', data[0]?.yxdy || [])
    },
    advanceSuccess() {},
    initDetail() {
      apiMonthplanFindById(this.conditions).then(res => {
        console.log(res.data)
        res.data.pyear += ''
        this.conditions = { ...this.conditions, ...res.data }
        this.gridOptions.data = res.data.ztcrmTgpplanM1List || []
        this.initCustome()
      })
    },
    saveData() {
      const params = JSON.parse(JSON.stringify(this.conditions))
      console.log(JSON.stringify(params))
      this.loading = true
      handlerFlow(params, this.processKey)
        .then(response => {
          this.loading = false
          if (!this.conditions.id) {
            this.conditions.id = response.data.bizId
            Object.assign(this.conditions, response.data.bizData)
            this.conditions.bizId = response.data.bizId
            this.conditions.taskId = response.data.taskId
            this.conditions.billCode = response.data.bizData.billCode
          }
          response.data.bizData.ztcrmTgpplanM1List.map(item => {
            item.zyxdyOptions = this.selectDataOptions['orgList']
          })
          this.gridOptions.data = response.data.bizData.ztcrmTgpplanM1List
          this.$message.success('保存成功')
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDialog(e, title, currentRow) {
      e.target.blur()
      this.showDialog = true
      this.dialogTitle = title
      currentRow && (this.currentRow = currentRow)
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()

      if (!data) return
      if (this.dialogTitle === '客户选择') {
        this.conditions.partner = data.customerCode
        this.conditions.customerName = data.customerName
        this.conditions.customerType = data.customerType
        this.$set(this.selectDataOptions, 'orgList', data.clientOrgList)
      } else {
        this.currentRow.productId = data.productCode
        console.log(data)
      }
      this.showDialog = false
    },
    validate(cb) {
      this.$refs['form'].validate(valid => {
        if (valid) {
          cb()
        }
      })
    },
    insertData() {
      const columns = this.gridOptions.columns.filter(v => !v.type)
      const data = {}
      for (const key in columns) {
        data[columns[key].field] = ''
      }
      data.zyxdyOptions = this.selectDataOptions['orgList']
      this.gridOptions.data.unshift(data)
    },
    async removeData() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()
      // const hasIds = checkedList.filter(v => v.id)

      // if (hasIds.length) {
      //   const ids = hasIds.map(v => v.id).join(',')
      //   await deleteDeliverControl({ ids })
      // }
      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>

.page-container {
  padding: 10px;
  text-align: left;
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/deliveryPlanApprove.vue